export default __webpack_public_path__ + "static/media/icon-withdraw.a5c14cee.svg";